import { render, staticRenderFns } from "./navigate-top.vue?vue&type=template&id=3cd2772a&scoped=true&"
import script from "./navigate-top.vue?vue&type=script&lang=js&"
export * from "./navigate-top.vue?vue&type=script&lang=js&"
import style0 from "./navigate-top.vue?vue&type=style&index=0&id=3cd2772a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2772a",
  null
  
)

export default component.exports